export const formataDescricao = ({ nuLinha, deOrigem, deDestino }) => {
  return `${nuLinha || ''} - ${deOrigem || ''} - ${deDestino || ''}`;
};

export const onSelectMunicipio = ({ event, cityObj, setFieldValue, polos }) => {
  let cdMunicipio = Number(event.target.value);
  const found = polos.find(city => city.cdMunicipio === cdMunicipio);
  setFieldValue(event.target.name, event.target.value);
  setFieldValue(cityObj, found);
};
